import { render, staticRenderFns } from "./FaqsSection.vue?vue&type=template&id=5a4cf570&"
import script from "./FaqsSection.vue?vue&type=script&lang=js&"
export * from "./FaqsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports